import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { URLS } from 'src/app/constants/URLS';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  userName: String;
  user_id: string;
  contact: string;
  profileBaseUrl: string = URLS.profileImageBaseUrl;
  profileImage: string;
  isGuest: boolean = false;

  constructor(
    private authService: AuthenticateserviceService,
    private router: Router,
    private whitelabelService: WhiteLabelService
  ) {
    this.isGuest = this.authService.isGuest();
    if (!this.isGuest) {
      this.initializingData();
    }
  }

  initializingData() {
    this.userName = localStorage.getItem("userName");
    this.profileImage = localStorage.getItem("profileImage");
    if (Number(localStorage.getItem("userId")) > 0)
      this.user_id = localStorage.getItem("userId").toString();
    this.contact = localStorage.getItem('contact');
  }

  goToLogin(): void {
    localStorage.setItem('redirectAfterLogin', this.router.url);
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
